import type { Router } from "vue-router";
import { showToast } from "vant";

// 小程序页面路径 -> H5 路由映射
const pageRoutes: Record<string, string> = {
  "/pages/home/index": "/home",
  "/pages/work/index": "/work",
  "/pages/time/report/index": "/time/report",
  "/pages/door/open/list": "/door/open/list",
  "/pages/door/open/info": "/door/open/info",
  "/pages/door/visitor/list": "/door/visitor/list",
  "/meet/home": "/meet/home",
  "/meet/room": "/meet/room",
  "/meet/reservation": "/meet/reservation",
  "/meet/my/reservation": "/meet/my/reservation",
  "/meet/my/meeting": "/meet/my/meeting",
};

/**
 * 菜单跳转（适配自小程序 wx.navigateTo）
 * 已迁移的页面跳转到 H5 路由，未迁移的页面提示无权限
 */
export const gotoMiniPage = (router: Router, url?: string, query?: string) => {
  if (!url) {
    showToast("敬请期待");
    return;
  }
  const route = pageRoutes[url];
  if (!route) {
    showToast("敬请期待");
    return;
  }
  void router.push(route + (query ? `?query=${query}` : ""));
};
